import axios from "axios";

axios.interceptors.response.use(
    response => response,
    error => {
        console.log(error.response)
        console.log(error.message)

        if (error.response?.status === 401) {
            window.location.href = process.env.REACT_APP_LOGIN_REDIRECT ?? "/login"
        }
        return Promise.reject(error)
    }
)
